import type { Space } from '@rock/types';

/**
 * Pill-sized labels for the spaces whose `name` is too long or too roundabout at that size. There is
 * no `shortTitle` on Space (only `name` and `systemTitle`, and `systemTitle` means the "…System"
 * phrasing — "Other Systems" for garage — so it can't be derived from). Overriding the label here
 * rather than renaming the space keeps the app's own copy untouched; if these names turn out to be
 * wanted elsewhere, the durable fix is a real `shortTitle` field like EquipmentType already has.
 */
const SPACE_PILL_LABELS: Record<string, string> = {
    home: 'Home',
    hvac: 'HVAC',
    safety: 'Safety',
    garage: 'Garage',
    'exterior-surfaces': 'Exterior',
};

/** What a space is called on a filter pill — its short label if it has one, else its name. */
export function spacePillLabel(space: Pick<Space, 'id' | 'name'>): string {
    return SPACE_PILL_LABELS[space.id] ?? space.name;
}
